import httpCommerce from './httpCommerce';
import { getToken } from '@vue/services/jwt.service';

export const getCurrencies = () => {
  return httpCommerce.get('/api/currencies')
}

export const getRate = async params => {
  const affiliateCode = sessionStorage.getItem('affiliateCode') || null;
  
  const url = affiliateCode
    ? `/rates/${params.transactionType}/${params.currency}?affiliateCode=${affiliateCode}`
    : `/rates/${params.transactionType}/${params.currency}`;

    const token = await getToken();

    if(token) {
      return httpCommerce.get(url, {
        headers: {
          Authorization: `bearer ${token}`
        }
      });
    } else {
      return httpCommerce.get(url);
    }
}

// Provisional pending further refactoring
export const mapRateDetailToLegacyFormat = newRateDetail => {
  const oldRateDetail = {};

  oldRateDetail.currencyCode = newRateDetail.currency;
  oldRateDetail.price = newRateDetail.tiers[0].rate ? 1 / newRateDetail.tiers[0].rate : null;
  oldRateDetail.rate = newRateDetail.tiers[0].rate;
  oldRateDetail.rateTiers = newRateDetail.tiers.slice(1,);
  oldRateDetail.rateTiers = newRateDetail.tiers.slice(1,).map(tier => ({
    rate: tier.rate,
    amount: tier.thresholdAmount,
    price: tier.rate ? 1 / tier.rate : null
  }));

  return oldRateDetail;
}

export default { getCurrencies, getRate, mapRateDetailToLegacyFormat }
